import React, { useState, useEffect } from "react";
import Iframe from "react-iframe";

import "./popup.styles.scss";

class Popup2 extends React.Component {
  componentDidMount() {
    console.log(this.props.simulatorData);
  }
  render() {
    return (
      <div className="popup" id="popup">
        <div className="popup__content">
          <div className="popup__right">
            <a
              onClick={() => {
                this.props.setpopupToggle2(false);
              }}
              href="#popup"
              className="popup__close"
            >
              &times;
            </a>

            {this.props.simulatorData === null ? (
              <h3>No Document is Present!</h3>
            ) : (
              <div>
                <h3>Document is loading...</h3>
                <Iframe
                  url={this.props.simulatorData}
                  id="popup__pdf"
                  className="pdfClassname"
                  display="initial"
                  position="relative"
                />
              </div>
            )}
            {/* <h1>PDF is loading...</h1>

            <Iframe
              url={this.props.simulatorData}
              id="popup__pdf"
              className="pdfClassname"
              display="initial"
              position="relative"
            /> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Popup2;
